module.exports = __webpack_public_path__ + "img/feature_buy_zh.94b4c8f8.png";